"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deprecatedFn = exports.logDeprecated = void 0;
exports.logDeprecated = function (message) {
    console.warn("DEPRECATED: " + message);
};
exports.deprecatedFn = function (message) { return function (fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var deprecationMessage = message !== undefined
            ? "\"" + fn.name + "\" function is deprecated with message \"" + message + "\""
            : "\"" + fn.name + "\" function is deprecated";
        exports.logDeprecated(deprecationMessage);
        return fn.apply(void 0, args);
    };
}; };
//# sourceMappingURL=deprecated.js.map